import ajax from '@/utils/ajax';

export const head = '/web';

// 协议列表
export const resMyagreement = (data) => ajax(`${head}/v1/user-agreement/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&queryType=1`);

// 根据开课id查询协议信息、用户协议签署情况
export const resAgreementInfo = (data) => ajax(`${head}/v1/user-agreement/info?userProductId=${data}`);

// 签署协议
export const resSignedAgreement = (data) => ajax(`${head}/v1/user-agreement`, data, 'POST');

// 签署协议
export const resAgreementAlert = (id) => ajax(`${head}/v1/user-agreement/not-alert?id=${id}`, '', 'PUT');


// 协议列表新
export const reqMyagreement = (data) => ajax(`${head}/v1/user-agreement/list-agreement?pageNum=${data.pageNum}&pageSize=${data.pageSize}`);

// 用户申请重读
export const reqUserReread = (data) => ajax(`${head}/v1/reread-application/apply`, data, 'POST');

// c端重读申请审核详情接口
export const reqAuditReread = (agreementId) => ajax(`${head}/v1/reread-application/audit-detail?agreementId=${agreementId}`, '', 'GET');
